<template>
    <ul class="parsley-errors-list filled" v-if="validation.$error">
        <li v-for="(param, k) in errors" :key="k">
            <span v-if="param.message">{{ param.message }}</span>
            <span v-else-if="param.type === 'numeric'">Bitte geben Sie nur ganze Zahlen ein.</span>
            <span v-else-if="param.type === 'decimal'">Bitte geben Sie nur Zahlen mit Dezimalstellen ein.</span>
            <span v-else-if="param.type === 'email'">Bitte geben Sie eine gültige E-Mail Adresse ein.</span>
            <span v-else-if="param.type === 'url'">Bitte geben Sie eine vollständige URL (inkl. http://) ein.</span>
            <span v-else-if="param.type === 'phone'">Bitte geben Sie eine gültige Telefonnummer ein.</span>
            <span v-else-if="param.type === 'between'">Bitte Sie eine Zahl zwischen {{ param.min }} und {{ param.max }} ein.</span>
            <span v-else-if="param.type === 'required'">{{ empty }}</span>
            <span v-else>Bitte überprüfen Sie ihre Eingabe.</span>
        </li>
    </ul>
</template>

<script>
    export default {
        props: {
            validation: {
                type: Object,
                required: true,
            },
            empty: {
                type: String,
                default: 'Bitte füllen Sie dieses Feld aus.',
            },
        },

        computed: {
            errors: vm => Object.keys(vm.validation.$params)
                .filter(k => !vm.validation[k])
                .map(k => vm.validation.$params[k]),
        },
    };
</script>
